import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  margin: ${theme.spacing(2, 0)};
`;
